import React from "react";

interface AlertBannerV2Props {
  completionPercent: number;
}

const AlertBannerV2: React.FC<AlertBannerV2Props> = ({ completionPercent }) => {
  return (
    <div className="bg-[#FFFCF5] border border-[#FFCB47] text-[#D48806] rounded-md px-6 py-4 mb-4 text-base font-medium">
      Profiles over <span className="font-bold">70%</span> get 3x more views. You’re at <span className="font-bold">{completionPercent}%</span>.
    </div>
  );
};

export default AlertBannerV2; 